/* feetheart-a11y-patch.js
   Patches Shopeetech BIS (back-in-stock) third-party popup so it passes WCAG AA.
   Adds: form labels, accessible button names, focus management.
   Applied 2026-05-10. */

(function () {
  'use strict';

  function patchBisPopup() {
    var popups = document.querySelectorAll('.shopeetech-bis-popup, [id^="bis_popup"], [class*="back-in-stock"]');
    if (!popups.length) return;

    popups.forEach(function (popup) {
      // 1. Inputs without labels — add aria-label fallback
      popup.querySelectorAll('input:not([aria-label]):not([aria-labelledby])').forEach(function (input) {
        var name = input.getAttribute('name') || input.getAttribute('placeholder') || '';
        if (input.type === 'email' || /email/i.test(name)) {
          input.setAttribute('aria-label', 'Your email address');
        } else if (input.type === 'tel' || /phone/i.test(name)) {
          input.setAttribute('aria-label', 'Your phone number');
        } else if (input.type !== 'hidden' && input.type !== 'submit' && input.type !== 'button') {
          input.setAttribute('aria-label', name || 'Input field');
        }
      });

      // 2. Buttons without text — add accessible name
      popup.querySelectorAll('button:not([aria-label])').forEach(function (btn) {
        var visibleText = (btn.textContent || '').trim();
        if (!visibleText) {
          if (btn.classList.contains('close') || btn.getAttribute('data-action') === 'close' || /×|✕|✖/.test(btn.innerHTML)) {
            btn.setAttribute('aria-label', 'Close popup');
          } else if (btn.type === 'submit') {
            btn.setAttribute('aria-label', 'Notify me when back in stock');
          } else {
            btn.setAttribute('aria-label', 'Action button');
          }
        }
      });

      // 3. Close icon links without text
      popup.querySelectorAll('a:not([aria-label])').forEach(function (a) {
        var visibleText = (a.textContent || '').trim();
        if (!visibleText) {
          a.setAttribute('aria-label', 'Close');
        }
      });

      // 4. Make popup container an accessible dialog
      if (!popup.getAttribute('role')) popup.setAttribute('role', 'dialog');
      if (!popup.getAttribute('aria-modal')) popup.setAttribute('aria-modal', 'true');
      if (!popup.getAttribute('aria-label') && !popup.getAttribute('aria-labelledby')) {
        popup.setAttribute('aria-label', 'Back in stock notification');
      }
    });
  }

  // Run on load and observe for dynamically inserted popups
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchBisPopup);
  } else {
    patchBisPopup();
  }

  var observer = new MutationObserver(function (mutations) {
    var hasNewNode = mutations.some(function (m) { return m.addedNodes.length > 0; });
    if (hasNewNode) patchBisPopup();
  });
  observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
